import { Heading, Text, VFlow } from 'bold-ui'
import { CondicaoMaternalDbEnum } from 'graphql/types.generated'
import { useMemo } from 'react'
import { condicaoMaternalRecord } from 'types/enums'
import { isEmpty } from 'util/checks'
import { stringGrouper } from 'util/string/string-grouper'

interface CondicoesVacinacaoProps {
  condicaoMaternal: CondicaoMaternalDbEnum
  viajante: boolean
  comunicanteHanseniase: boolean
}

export default function CondicoesVacinacao(props: CondicoesVacinacaoProps) {
  const { condicaoMaternal } = props

  const outrasCondicoes = useMemo(() => mountOutrasCondicoesString(props), [props])

  if (!condicaoMaternal && isEmpty(outrasCondicoes)) {
    return null
  }

  return (
    <VFlow>
      {condicaoMaternal && (
        <VFlow vSpacing={0.5}>
          <Heading level={3}>Condição maternal</Heading>
          <Text>{condicaoMaternalRecord[condicaoMaternal]?.defaultLabel}</Text>
        </VFlow>
      )}
      {!isEmpty(outrasCondicoes) && (
        <VFlow vSpacing={0.5}>
          <Heading level={3}>Outras condições</Heading>
          <Text>{outrasCondicoes}</Text>
        </VFlow>
      )}
    </VFlow>
  )
}

const mountOutrasCondicoesString = (condicoes: CondicoesVacinacaoProps) => {
  const { viajante, comunicanteHanseniase } = condicoes
  const cond: string[] = []

  viajante && cond.push('Viajante')
  comunicanteHanseniase && cond.push('Comunicante de hanseníase')

  return stringGrouper(...cond)
}
